// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
  margin-top: 20px;
  text-align: center;
}

.login-title-logo {
  margin: 10px auto;
  max-width: 620px;
  display: block;
}

.login-title-logo img {
  width: 50%;
  display: block;
  margin: 0 auto 0 auto;
}

.preauth-input-form {
  max-width: 620px;
  margin: 20px auto 10% auto;
  text-align: center;
}

.preauth-input-form-inner {
  padding-top: 5px;
  background: #f2f2f2;
  border: 1px solid #c0c0c0;
}

.preauth-input-form h3 {
  color: #ffffff;
  background: #909092;
  padding: 15px;
  margin-top: 0;
  margin-bottom: 0;
}

.input-wrapper {
  display: block;
  margin: 20px;
  background: #ffffff;
  border-radius: 5px;
}

.input-wrapper input {
  border: 1px solid #dcdcdc;
}

.forgot-password-button {
  display: inline-block;
  font-weight: 400;
  text-align: center;
  vertical-align: middle;
  margin: 0 20px 20px 20px;
  height: 40px;
  min-width: 120px;
  width: calc(50% - 2px);
  border-radius: 5px;
  color: #4330ff;
  background: #f2f2f2;
  border-width: 1px;
  border-color: #c0c0c0;
}

.reset-password-form {
  text-align: center;
}
.reset-password-form input {
  margin-bottom: 10px;
}
.reset-password-form .page-title-nav {
  min-height: 41px;
}
.reset-password-form .submit-button {
  border-radius: 5px;
  min-width: 75%;
  border-width: 1px;
}
.reset-password-form .submit-button:disabled {
  background-color: #eaeaea;
  color: #404040;
  cursor: not-allowed;
}

.app-download-callouts .callout {
  display: inline-block;
  margin: 5px;
}

.footer {
  margin-top: 15px;
}
.footer .footer-link {
  display: inline-block;
  min-width: 150px;
}
.footer .footer-link a {
  font-size: 12px;
  color: #c0c0c0;
  text-decoration: underline;
}
.footer .footer-link a.footer-link-left {
  float: right;
}
.footer .footer-link a.footer-link-right {
  float: left;
}
.footer .footer-divider {
  display: inline-block;
  color: #c0c0c0;
  margin: 0px 10px 0px 10px;
}

`, "",{"version":3,"sources":["webpack://./src/components/LoginForm/loginForm.scss","webpack://./src/components/LoginForm/loginForm.css","webpack://./src/app/variables.scss"],"names":[],"mappings":"AAEA;EACE,gBAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;ACDF;;ADIA;EACE,UAAA;EACA,cAAA;EACA,qBAAA;ACDF;;ADIA;EACE,gBAAA;EACA,0BAAA;EACA,kBAAA;ACDF;;ADIA;EACE,gBAAA;EACA,mBElBc;EFmBd,yBAAA;ACDF;;ADIA;EACE,cAAA;EACA,mBErBkB;EFsBlB,aAAA;EACA,aAAA;EACA,gBAAA;ACDF;;ADIA;EACE,cAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;ACDF;;ADIA;EACE,yBAAA;ACDF;;ADIA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,wBAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,cElCY;EFmCZ,mBEpDc;EFqDd,iBAAA;EACA,qBAAA;ACDF;;ADIA;EACE,kBAAA;ACDF;ADEE;EACE,mBAAA;ACAJ;ADEE;EACE,gBAAA;ACAJ;ADEE;EACE,kBAAA;EACA,cAAA;EACA,iBAAA;ACAJ;ADCI;EACI,yBErEK;EFsEL,cEjEI;EFkEJ,mBAAA;ACCR;;ADKE;EACE,qBAAA;EACA,WAAA;ACFJ;;ADMA;EACE,gBAAA;ACHF;ADIE;EACE,qBAAA;EACA,gBAAA;ACFJ;ADGI;EACE,eAAA;EACA,cEvFQ;EFwFR,0BAAA;ACDN;ADEM;EACE,YAAA;ACAR;ADEM;EACE,WAAA;ACAR;ADIE;EACE,qBAAA;EACA,cEnGU;EFoGV,yBAAA;ACFJ","sourcesContent":["@import '../../app/variables.scss';\n\n.login-container {\n  margin-top: 20px;\n  text-align: center;\n}\n\n.login-title-logo {\n  margin: 10px auto;\n  max-width: 620px;\n  display: block;\n}\n\n.login-title-logo img{\n  width: 50%;\n  display: block;\n  margin: 0 auto 0 auto;\n}\n\n.preauth-input-form {\n  max-width: 620px;\n  margin: 20px auto 10% auto;\n  text-align: center;\n}\n\n.preauth-input-form-inner {\n  padding-top: 5px;\n  background: $lightest-gray;\n  border: 1px solid $medium-gray\n}\n\n.preauth-input-form h3{\n  color: #ffffff;\n  background: $medium-light-gray;\n  padding: 15px;\n  margin-top: 0;\n  margin-bottom: 0;\n}\n\n.input-wrapper {\n  display: block;\n  margin: 20px;\n  background: #ffffff;\n  border-radius: 5px;\n}\n\n.input-wrapper input{\n  border: 1px solid $medium-lightest-gray;\n}\n\n.forgot-password-button {\n  display: inline-block;\n  font-weight: 400;\n  text-align: center;\n  vertical-align: middle;\n  margin: 0 20px 20px 20px;\n  height: 40px;\n  min-width: 120px;\n  width: calc(50% - 2px);\n  border-radius: 5px;\n  color: $evanta-blue;\n  background: $lightest-gray;\n  border-width: 1px;\n  border-color: #c0c0c0;\n}\n\n.reset-password-form {\n  text-align: center;\n  input {\n    margin-bottom: 10px;\n  }\n  .page-title-nav {\n    min-height: 41px;\n  }\n  .submit-button {\n    border-radius: 5px;\n    min-width: 75%;\n    border-width: 1px;\n    &:disabled {\n        background-color: $light-gray;\n        color: $dark-gray;\n        cursor: not-allowed;\n    }\n  }\n}\n\n.app-download-callouts {\n  .callout {\n    display: inline-block;\n    margin: 5px;\n  }\n}\n\n.footer {\n  margin-top: 15px;\n  .footer-link {\n    display: inline-block;\n    min-width: 150px;\n    a {\n      font-size: 12px;\n      color: $medium-gray;\n      text-decoration: underline;\n      &.footer-link-left {\n        float: right;\n      }\n      &.footer-link-right {\n        float: left;\n      }\n    }\n  }\n  .footer-divider {\n    display: inline-block;\n    color: $medium-gray;\n    margin: 0px 10px 0px 10px;\n  }\n}\n",".login-container {\n  margin-top: 20px;\n  text-align: center;\n}\n\n.login-title-logo {\n  margin: 10px auto;\n  max-width: 620px;\n  display: block;\n}\n\n.login-title-logo img {\n  width: 50%;\n  display: block;\n  margin: 0 auto 0 auto;\n}\n\n.preauth-input-form {\n  max-width: 620px;\n  margin: 20px auto 10% auto;\n  text-align: center;\n}\n\n.preauth-input-form-inner {\n  padding-top: 5px;\n  background: #f2f2f2;\n  border: 1px solid #c0c0c0;\n}\n\n.preauth-input-form h3 {\n  color: #ffffff;\n  background: #909092;\n  padding: 15px;\n  margin-top: 0;\n  margin-bottom: 0;\n}\n\n.input-wrapper {\n  display: block;\n  margin: 20px;\n  background: #ffffff;\n  border-radius: 5px;\n}\n\n.input-wrapper input {\n  border: 1px solid #dcdcdc;\n}\n\n.forgot-password-button {\n  display: inline-block;\n  font-weight: 400;\n  text-align: center;\n  vertical-align: middle;\n  margin: 0 20px 20px 20px;\n  height: 40px;\n  min-width: 120px;\n  width: calc(50% - 2px);\n  border-radius: 5px;\n  color: #4330ff;\n  background: #f2f2f2;\n  border-width: 1px;\n  border-color: #c0c0c0;\n}\n\n.reset-password-form {\n  text-align: center;\n}\n.reset-password-form input {\n  margin-bottom: 10px;\n}\n.reset-password-form .page-title-nav {\n  min-height: 41px;\n}\n.reset-password-form .submit-button {\n  border-radius: 5px;\n  min-width: 75%;\n  border-width: 1px;\n}\n.reset-password-form .submit-button:disabled {\n  background-color: #eaeaea;\n  color: #404040;\n  cursor: not-allowed;\n}\n\n.app-download-callouts .callout {\n  display: inline-block;\n  margin: 5px;\n}\n\n.footer {\n  margin-top: 15px;\n}\n.footer .footer-link {\n  display: inline-block;\n  min-width: 150px;\n}\n.footer .footer-link a {\n  font-size: 12px;\n  color: #c0c0c0;\n  text-decoration: underline;\n}\n.footer .footer-link a.footer-link-left {\n  float: right;\n}\n.footer .footer-link a.footer-link-right {\n  float: left;\n}\n.footer .footer-divider {\n  display: inline-block;\n  color: #c0c0c0;\n  margin: 0px 10px 0px 10px;\n}\n\n","// Font colors\n$success-color: #38bb15;\n$warning-color: #feb52b;\n$error-color: #ff2e2e;\n$link-color: #428bca;\n\n$blue: #2d7cbf;\n$blue-light-gray: #d4e4e9;\n\n$lightest-gray: #f2f2f2;\n$light-gray: #eaeaea;\n$medium-lightest-gray: #dcdcdc;\n$medium-light-gray: #909092;\n$medium-gray: #c0c0c0;\n$medium-dark-gray: #606060;\n$dark-gray: #404040;\n\n$teal: #32c3b5;\n$gold: #f2b130;\n\n$light-base: #006AC7;\n$light-active: #264A82;\n$success-base: #00A76D;\n\n$eblack: #282829;\n$egrey: #dcddde;\n$evanta-blue: #4330ff;\n$evanta-blue-secondary: #5c4ee5;\n$gartner-blue: #002869;\n$active-slider: #3fe85c;\n$solar: #fa504b;\n$solar-secondary: #fb736f;\n$solar-tertiary: #DE0A01;\n\n\n// Font sizes\n$biggest-header: 36px;\n$big-header: 28px;\n$larger: 20px;\n$large: 16px;\n$medium: 14px;\n$small: 13px;\n$smaller: 12px;\n$tiny: 11px;\n\n// Homepage colors\n// $goldLight: #F9D889;\n// $goldPrimary: #F4B213;\n// $goldDark: #92451C;\n// $greenLight: #CDE3A5;\n// $greenPrimary: #9CC84B;\n// $greenDark: #416428;\n// $mintLight: #95E1DA;\n// $mintPrimary: #2BC4B6;\n// $mintDark: #00566B;\n// $purpleLight: #C6B1D4;\n// $purplePrimary: #8D64AA;\n// $purpleDark: #46295B;\n\n$goldLight: #F9D783;\n$goldPrimary: #92451C;\n$goldDark: #F5B51D;\n$greenLight: #C7E09A;\n$greenPrimary: #416428;\n$greenDark: #A0CA51;\n$mintLight: #8EDFD8;\n$mintPrimary: #02576C;\n$mintDark: #33C7B9;\n$purpleLight: #C3ADD2;\n$purplePrimary: #513465;\n$purpleDark: #9068AD;\n\n\n// virtual portal colors\n$vp-dark-gray: #6D6E71;\n$vp-black: #2C2C2C;\n$vp-bright-red: #FA504B;\n$vp-dark-gray-50op: rgba(109, 110, 113, 0.5)\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
